const state ={
  user_company_list: [], //公司列表
  add_tag1_list: [],    //tag1列表 品类
  add_tag2_list: [],    //tag2列表 分类
  add_tag3_list: [],    //tag3列表 性别
  add_company_list: [],   //客户组列表
}
const actions ={
  saveFormData({commit},payload){
    // console.log(payload);

    commit(payload.type, payload.data)
  }
}
const mutations ={
  user_company_list(state, payload){
    state.user_company_list = payload
  },
  add_tag1_list(state, payload){
    state.add_tag1_list = payload
  },
  add_tag2_list(state, payload){
    state.add_tag2_list = payload
  },
  add_tag3_list(state, payload){
    state.add_tag3_list = payload
  },
  add_company_list(state, payload){
    state.add_company_list = payload
  },
}
const getters ={}


export default {
  state, actions, mutations,getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/formData.js